{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "おはようございます",
        "afternoon": "こんにちは",
        "evening": "こんばんは"
      },
      "header": {
        "fallbackUser": "ユーザー",
        "facility": "施設 {{id}}"
      },
      "criticalBanner": {
        "message_one": "重要な検査結果{{count}}件の確認が必要です",
        "message_other": "重要な検査結果{{count}}件の確認が必要です",
        "reviewNow": "今すぐ確認"
      },
      "sections": {
        "overview": "概要",
        "tasks": "タスク",
        "myPatients": "担当患者",
        "recentActivity": "最近の活動",
        "quickActions": "クイックアクション"
      },
      "stats": {
        "activeEncounters": "進行中の受診",
        "pendingOrders": "保留中のオーダー",
        "resultsToReview": "確認待ちの検査結果",
        "criticalAlerts": "重要アラート"
      },
      "tasks": {
        "unsignedNotes": "未署名のノート",
        "criticalResultsPending": "確認待ちの重要結果",
        "cosignaturesNeeded": "共同署名が必要",
        "ordersToReview": "確認すべきオーダー",
        "activeMedications": "進行中の処方",
        "admissionsPending": "入院待ち",
        "ordersToVerify": "確認すべきオーダー(薬剤師)",
        "controlledSubstanceReviews": "麻薬等の確認",
        "systemAlerts": "システムアラート",
        "systemStatus": "システム状態"
      },
      "systemStatusValue": {
        "healthy": "正常"
      },
      "empty": {
        "noPatients": "担当患者は割り当てられていません。",
        "noTasks": "ロール別のタスクはありません。",
        "noRecentEncounters": "最近の受診はありません。"
      },
      "quickActions": {
        "findPatient": {
          "label": "患者検索",
          "description": "記録を検索"
        },
        "registerPatient": {
          "label": "患者登録",
          "description": "新規患者を追加"
        },
        "viewCensus": {
          "label": "在院数を表示",
          "description": "進行中の患者を一覧表示"
        },
        "reports": {
          "label": "レポート",
          "description": "分析を表示"
        }
      },
      "viewAll": "すべて表示",
      "bedLabel": "病床 {{n}}",
      "admittedLabel": "入院日 {{date}}",
      "fallback": {
        "unknownPatient": "不明な患者",
        "unknownType": "不明"
      },
      "acuity": {
        "1": "蘇生",
        "2": "緊急",
        "3": "準緊急",
        "4": "準急ぎ",
        "5": "緊急性なし"
      },
      "encounterType": {
        "emergency": "救急",
        "inpatient": "入院",
        "outpatient": "外来",
        "observation": "経過観察"
      },
      "encounterStatus": {
        "active": "進行中",
        "completed": "完了",
        "discharged": "退院",
        "cancelled": "取消",
        "pending": "保留中"
      }
    },
    "qualityMeasures": {
      "title": "品質指標",
      "subtitle": "臨床品質指標と規制遵守状況を追跡します",
      "refresh": "更新",
      "allTypesLabel": "すべての種類",
      "allFacilitiesLabel": "すべての施設",
      "targetPrefix": "目標: {{value}} {{unit}}",
      "updatedPrefix": "更新日時: {{value}}",
      "measureType": {
        "process": "プロセス",
        "outcome": "アウトカム",
        "structure": "ストラクチャー"
      },
      "summary": {
        "totalMeasures": "指標総数",
        "meetingTarget": "目標達成",
        "belowTarget": "目標未達"
      },
      "toasts": {
        "refreshSuccess": "指標を更新しました"
      },
      "results": {
        "title": "記録済み結果",
        "period": "期間",
        "facility": "施設",
        "denominator": "分母",
        "numerator": "分子",
        "exclusions": "除外",
        "rate": "率",
        "source": "ソース",
        "calculated": "計算日",
        "empty": "この期間・指標の記録済み結果はありません。",
        "loadError": "記録済み結果を読み込めませんでした。",
        "allFacilities": "すべての施設",
        "record": "結果を記録"
      },
      "sources": {
        "manual": "手動",
        "sql-template": "SQLテンプレート",
        "import": "インポート"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDAレポートをダウンロードしました",
        "error": "QRDAのダウンロードに失敗しました"
      },
      "record": {
        "title": "品質結果の記録",
        "titleFor": "結果の記録 — {{code}} {{name}}",
        "subtitle": "記録された結果は指標の履歴に表示され、QRDA カテゴリ III エクスポートに反映されます。同じ期間を再記録すると、以前の行が置き換えられます。",
        "back": "品質指標に戻る",
        "cancel": "キャンセル",
        "save": "結果を記録",
        "measureNotFound": "指標が見つかりません。無効化された可能性があります。",
        "fields": {
          "periodStart": "期間開始",
          "periodEnd": "期間終了",
          "facility": "施設",
          "allFacilities": "すべての施設",
          "denominator": "分母",
          "numerator": "分子",
          "exclusions": "除外",
          "source": "算出元",
          "completeness": "データ完全性",
          "completenessHint": "データが完全な対象レコードの割合（0～1）。不明な場合は空欄のままにしてください。",
          "notes": "備考"
        },
        "errors": {
          "periodStartRequired": "期間開始は必須です",
          "periodEndRequired": "期間終了は必須です",
          "periodOrder": "期間終了は期間開始以降の日付にしてください",
          "countInvalid": "0 以上の整数を入力してください",
          "numeratorExceeds": "分子は分母を超えることはできません",
          "numeratorExceedsNet": "分子は分母から除外を差し引いた値を超えることはできません",
          "sourceRequired": "算出元は必須です",
          "completenessRange": "完全性は 0 から 1 の範囲で入力してください"
        },
        "toast": {
          "success": "結果を記録しました",
          "error": "記録に失敗しました"
        }
      }
    },
    "analyticsDashboard": {
      "title": "分析ダッシュボード",
      "subtitle": "病院運営の指標と推移",
      "refresh": "更新",
      "changeVsPrevPeriod": "前期比 {{sign}}{{value}}%",
      "dateRange": {
        "today": "本日",
        "7d": "過去7日",
        "30d": "過去30日",
        "90d": "過去90日"
      },
      "facility": {
        "all": "すべての施設",
        "sgh": "SGH - シンガポール総合病院",
        "nuh": "NUH - シンガポール国立大学病院",
        "ttsh": "TTSH - タン・トック・セン病院"
      },
      "department": {
        "all": "すべての診療科",
        "er": "救急科",
        "icu": "集中治療室",
        "medsurg": "内科外科",
        "peds": "小児科",
        "maternity": "産科"
      },
      "widget": {
        "census": {
          "title": "現在の在院数"
        },
        "bedOccupancy": {
          "title": "病床稼働率"
        },
        "avgLOS": {
          "title": "平均在院日数"
        },
        "throughput": {
          "title": "総受診件数"
        },
        "readmission": {
          "title": "保留中のオーダー"
        }
      },
      "unit": {
        "patients": "人",
        "days": "日",
        "encounters": "件",
        "orders": "件"
      },
      "charts": {
        "admissionsVsDischarges": "入院と退院",
        "admissionsByDepartment": "診療科別入院数",
        "encounterTypes": "受診タイプ",
        "censusTrend": "在院数の推移",
        "insufficientData": "グラフを表示するためのデータが不足しています",
        "insufficientTrendData": "推移グラフを表示するためのデータが不足しています"
      },
      "series": {
        "admissions": "入院",
        "discharges": "退院",
        "census": "在院数"
      },
      "toasts": {
        "refreshSuccess": "ダッシュボードを更新しました"
      }
    },
    "reportRunner": {
      "title": "レポート実行",
      "subtitle": "臨床・財務・運営レポートを作成・エクスポートします",
      "scheduleButton": "レポートをスケジュール",
      "searchPlaceholder": "レポートを検索...",
      "allCategoriesLabel": "すべてのレポート",
      "category": {
        "clinical": "臨床",
        "financial": "財務",
        "operational": "運営",
        "quality": "品質"
      },
      "emptyState": {
        "title": "レポートを選択して開始してください",
        "subtitle": "左側のレポート一覧から選択してください"
      },
      "noResults": "条件に一致するレポートはありません",
      "parametersHeading": "パラメータ",
      "selectOptionPlaceholder": "選択...",
      "runButton": "レポートを実行",
      "runningReport": "レポートを実行中...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "日付(施設ローカル時刻)",
        "facilityTimeZone": "施設のタイムゾーン",
        "encounterDate": "日付(UTC)"
      },
      "resultSummary": {
        "rows": "{{total}}件中{{shown}}件を表示",
        "executed": "実行時間: {{ms}}ms"
      },
      "toasts": {
        "success": "レポートが完了しました({{executionTimeMs}}ms、{{rowCount}}件)",
        "failed": "レポートの実行に失敗しました",
        "missingFields": "必須項目を入力してください: {{missingFields}}",
        "exporting": "{{format}}としてエクスポート中...(プレースホルダー)",
        "scheduledPlaceholder": "スケジュールレポートの設定(プレースホルダー)"
      }
    }
  }
}
